export const formatRallyFinishTime = (finishTimeSeconds: number | null | undefined) =>
  finishTimeSeconds === null || finishTimeSeconds === undefined
    ? null
    : `${finishTimeSeconds.toFixed(2)} s`;
